import { usePageTitle } from "../hooks/usePageTitle";
import ActiveDropScreen from "../components/drop/ActiveDropScreen";

const ForecastDrop = () => {
    usePageTitle("forecast_drop");
    return <ActiveDropScreen module="forecast" titleKey="forecast_drop" />;
};

export default ForecastDrop;
